import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeIn } from "@/components/Reveal";

export const CtaBand = () => (
  <section className="bg-charcoal text-offwhite py-24 md:py-32 grain relative" data-testid="cta-band">
    <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
      <FadeIn>
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-white">
          Looking to reach an audience that values <em className="italic text-mutedblue">knowledge</em>?
        </h2>
        <p className="mt-6 text-base md:text-lg text-offwhite/70 leading-relaxed max-w-2xl mx-auto">
          Tell us about your brand and campaign objectives. We'll explore whether
          informational YouTube is the right fit.
        </p>
        <Link
          to="/contact"
          data-testid="cta-band-button"
          className="group mt-10 inline-flex items-center gap-3 bg-offwhite text-ink px-9 py-4 text-sm tracking-wide transition-colors duration-300 hover:bg-mutedblue hover:text-white"
        >
          Discuss a Campaign
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </FadeIn>
    </div>
  </section>
);
